module.exports = __webpack_public_path__ + "img/d12.e0b3bafe.svg";